import { defineStore } from "pinia";
import state from "./state";
import actions from "./actions";

export const useStatisticsStore = defineStore("statistics", {
  state,
  actions: actions(),
});
